import { render, staticRenderFns } from "./SignUpPageMasterUser.vue?vue&type=template&id=c28d1050&"
import script from "./SignUpPageMasterUser.vue?vue&type=script&lang=js&"
export * from "./SignUpPageMasterUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports